"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateAdjustmentFromVoucher = exports.isVoucherAppliedOnOrder = void 0;
const domain_1 = require("@oolio-group/domain");
const isAdjustmentVoucher = (adjustment, voucherCode) => adjustment.id === domain_1.CUSTOM_ADJUSTMENT_ID && adjustment.name === voucherCode;
/**
 * Description: This function checks whether any voucher is applied on the order and any of the order items
 * @param {order} order: Order info
 * @returns {boolean}
 */
const isVoucherAppliedOnOrder = (order, voucherCode) => {
    var _a, _b;
    const orderHasVoucher = (_a = order.adjustments) === null || _a === void 0 ? void 0 : _a.some(adjustment => isAdjustmentVoucher(adjustment, voucherCode));
    const orderItemHasVoucher = (_b = order.orderItems) === null || _b === void 0 ? void 0 : _b.some(orderItem => {
        var _a;
        return (_a = orderItem === null || orderItem === void 0 ? void 0 : orderItem.adjustments) === null || _a === void 0 ? void 0 : _a.some(adjustment => isAdjustmentVoucher(adjustment, voucherCode));
    });
    return orderHasVoucher || orderItemHasVoucher;
};
exports.isVoucherAppliedOnOrder = isVoucherAppliedOnOrder;
/**
 * Description: This function converts voucher info into adjustments
 * @param {Order} order Order info
 * @param {Voucher} voucher Voucher info
 * @returns {{
 *  orderAdjustments: Adjustment[],
 *  orderItemAdjustments: Adjustment[],
 *  productId?: string
 * }} object containg adjustments
 */
const generateAdjustmentFromVoucher = (order, voucher) => {
    var _a;
    // Considering single product id per voucher
    const voucherProductId = (_a = voucher.productIds) === null || _a === void 0 ? void 0 : _a[0];
    const orderAdjustments = [];
    const orderItemAdjustments = [];
    let productError = false;
    if (voucher.voucherType === domain_1.VoucherType.CASH) {
        orderAdjustments.push({
            id: domain_1.CUSTOM_ADJUSTMENT_ID,
            name: voucher.id,
            amount: -Number(Math.min(voucher.voucherValue, (order === null || order === void 0 ? void 0 : order.amountDue) || voucher.voucherValue)),
            adjustmentUnit: domain_1.AdjustmentUnit.FLAT,
            allowOnPaymentType: false,
            adjustmentType: domain_1.AdjustmentType.DISCOUNT,
        });
    }
    else if (voucher.voucherType === domain_1.VoucherType.DISCOUNT) {
        orderAdjustments.push({
            id: domain_1.CUSTOM_ADJUSTMENT_ID,
            name: voucher.id,
            amount: -Number(voucher.voucherValue * 100),
            adjustmentUnit: domain_1.AdjustmentUnit.PERCENTAGE,
            allowOnPaymentType: false,
            adjustmentType: domain_1.AdjustmentType.DISCOUNT,
        });
    }
    else if (voucher.voucherType === domain_1.VoucherType.PRODUCT && voucherProductId) {
        const matchingCartItem = order.orderItems.find(orderItem => { var _a; return ((_a = orderItem.product) === null || _a === void 0 ? void 0 : _a.id) === voucherProductId; });
        if (matchingCartItem) {
            orderItemAdjustments.push({
                id: domain_1.CUSTOM_ADJUSTMENT_ID,
                name: voucher.id,
                amount: -Number(voucher.voucherValue),
                adjustmentUnit: domain_1.AdjustmentUnit.FLAT,
                allowOnPaymentType: false,
                adjustmentType: domain_1.AdjustmentType.DISCOUNT,
            });
        }
        else {
            productError = true;
        }
    }
    return {
        orderAdjustments,
        orderItemAdjustments,
        productId: voucherProductId,
        productError,
    };
};
exports.generateAdjustmentFromVoucher = generateAdjustmentFromVoucher;
//# sourceMappingURL=helpers.js.map